import { momentumConstants } from '../_constants';
import { momentumService } from '../_services';
import { alertActions } from './';

export const momentumActions = {
  listMomentums,
  listFilters,
  listAvailableChannels,
  storeMomentum,
  softDeleteMomentum,
  listMomentumById,
  updateMomentum,
  updateMomentumStatus,
  listCustomFilters
}

function listMomentums(domain) {
  return dispatch => {
    dispatch(request('LIST_MOMENTUMS_REQUEST', {domain}));

    return momentumService.listMomentums(domain)
      .then(data => {
        dispatch(alertActions.success(data));
        return dispatch(success('LIST_MOMENTUMS_SUCCESS', data));
      }, error => {
        dispatch(alertActions.failure(error));
        return dispatch(failure('LIST_MOMENTUMS_FAILURE', error));
      })
  }
}

function listMomentumById(uuid) {
  return dispatch => {
    dispatch(request('LIST_MOMENTUM_BY_ID_REQUEST', {uuid}));

    return momentumService.listMomentumById(uuid)
      .then(data => {
        dispatch(alertActions.success(data));
        return dispatch(success('LIST_MOMENTUM_BY_ID_SUCCESS', data));
      }, error => {
        dispatch(alertActions.failure(error));
        return dispatch(failure('LIST_MOMENTUM_BY_ID_FAILURE', error));
      })
  }
}

function listFilters(data) {
  return dispatch => {
    dispatch(request('LIST_FILTERS_REQUEST', {data}));

    return momentumService.listFilters(data)
      .then(
        async data => {
          dispatch(success('LIST_FILTERS_SUCCESS', data));
          let filters = data.data;

          // Removing duplicated values from Backend
          data.data = Array.from(new Set(filters.map(JSON.stringify))).map(JSON.parse);

          return sessionStorage.setItem('cellit_available_filters', JSON.stringify(data));
        },
        error => {
          dispatch(failure('LIST_FILTERS_FAILURE', error));
          return dispatch(alertActions.failure(error));
        }
      )
  }
}

function listCustomFilters(data, filterBy) {
  return dispatch => {
    dispatch(request('LIST_CUSTOM_FILTERS_REQUEST', {data}));

    return momentumService.listCustomFilters(data, filterBy)
      .then(
        data => {
          dispatch(success('LIST_CUSTOM_FILTERS_SUCCESS', data));
          return dispatch(alertActions.success(data));
        },
        error => {
          dispatch(failure('LIST_CUSTOM_FILTERS_FAILURE', error));
          return dispatch(alertActions.failure(error));
        }
      )
  }
}

function listAvailableChannels(domain_uuid) {
  return dispatch => {
    dispatch(request('LIST_CHANNELS_REQUEST', {domain_uuid}));

    return momentumService.listAvailableChannels(domain_uuid)
      .then(data => {
        return dispatch(success('LIST_CHANNELS_SUCCESS', data));
      }, error => {
        return dispatch(failure('LIST_CHANNELS_FAILURE', error));
      })
  }
} 

function storeMomentum(data) {
  return dispatch => {
    dispatch(request('STORE_MOMENTUM_REQUEST', {data}));

    return momentumService.storeMomentum(data)
      .then(data => {
        return dispatch(success('STORE_MOMENTUM_SUCCESS', data));
      }, error => {
        return dispatch(failure('STORE_MOMENTUM_FAILURE', error));
      })
  }
}

function updateMomentum(data) {
  return dispatch => {
    dispatch(request('UPDATE_MOMENTUM_REQUEST', {data}));

    return momentumService.updateMomentum(data)
      .then(data => {
        return dispatch(success('UPDATE_MOMENTUM_SUCCESS', data));
      }, error => {
        return dispatch(failure('UPDATE_MOMENTUM_FAILURE', error));
      })
  }
}

function updateMomentumStatus(data, requestType, domain) {
  return dispatch => {
    dispatch(request('UPDATE_MOMENTUM_REQUEST', {data, requestType}));

    return momentumService.updateMomentumStatus(data, requestType, domain)
      .then(data => {
        return dispatch(success('UPDATE_MOMENTUM_SUCCESS', data));
      }, error => {
        return dispatch(failure('UPDATE_MOMENTUM_FAILURE', error));
      })
  }
}

function softDeleteMomentum(uuid, domain, data) {
  return dispatch => {
    dispatch(request('REMOVE_MOMENTUM_REQUEST', {uuid}));

    return momentumService.softDeleteMomentum(uuid, domain, data)
      .then(data => {
        return dispatch(success('REMOVE_MOMENTUM_SUCCESS', data));
      }, error => {
        return dispatch(failure('REMOVE_MOMENTUM_FAILURE', data));
      })
  }
}

const request = (constant, data) => {
  return { type: momentumConstants[constant], data }
}

const success = (constant, data) => {
  return { type: momentumConstants[constant], data }
}

const failure = (constant, error) => {
  return { type: momentumConstants[constant], error }
}